"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.countComponent = exports.postComponent = exports.updateComponent = exports.associateProductToComponent = exports.partialUpdateComponent = exports.deleteComponentService = exports.getComponents = exports.controller = void 0;
const api_1 = require("@/services/api");
const CustomError_1 = __importDefault(require("@/domains/Utilities/CustomError"));
const ENDPOINT = "/components";
exports.controller = new AbortController();
function getComponents() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}`)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Components Error]: ${error.message}`);
    });
}
exports.getComponents = getComponents;
function deleteComponentService(componentId) {
    return api_1.axiosInstance
        .delete(`${ENDPOINT}/${componentId}`, { signal: exports.controller.signal })
        .then((response) => {
        return response.status;
    })
        .catch((error) => {
        if (error.response?.status === 400) {
            throw new CustomError_1.default("Component is already associated to a product", error.response.status);
        }
        throw new Error(`[Components Error]: ${error.message}`);
    });
}
exports.deleteComponentService = deleteComponentService;
function partialUpdateComponent(componentId, newData) {
    return api_1.axiosInstance
        .patch(`${ENDPOINT}/${componentId}`, newData)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Partial Update Components Error]: ${error.message}`);
    });
}
exports.partialUpdateComponent = partialUpdateComponent;
function associateProductToComponent(componentId, productstToBeAssociated) {
    return api_1.axiosInstance
        .patch(`${ENDPOINT}/${componentId}/products`, productstToBeAssociated)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Associate Products to Components Error]: ${error.message}`);
    });
}
exports.associateProductToComponent = associateProductToComponent;
function updateComponent(componentId, newData) {
    return api_1.axiosInstance
        .put(`${ENDPOINT}/${componentId}`, newData)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Update Components Error]: ${error.message}`);
    });
}
exports.updateComponent = updateComponent;
function postComponent(componentData) {
    return api_1.axiosInstance
        .post(`${ENDPOINT}`, componentData)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Post Components Error]: ${error.message}`);
    });
}
exports.postComponent = postComponent;
function countComponent() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}/count`)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Count Components Error]: ${error.message}`);
    });
}
exports.countComponent = countComponent;
